import React, { useEffect, useState } from "react";
import { Modal, ModalBody, ModalHeader } from "react-bootstrap";
import { AdminButton } from "../../buttons/versionHistoryBtn";
import searcher from "../../../assets/icons/searchInput.svg";
import TableContainer from "../../layout/table-container/table-container";
import "./manufacturerModal.css";
import DoctorVerificationTableData from "./DoctorVerificationTableData";
import { useDispatch } from "react-redux";
import { doctorBulkVerify } from "../../../redux/actions/manufacturerActions";
import DoctorBulkErrorModal from "./bulkupload-error-modals/doctorBulkErrorModal";
import ErrorPopup from "../../popups/ErrorPopup";
import UnablePopup from "../../popups/UnablePopUp";
import SuccessPopup from "../../popups/SuccessPopup";

const DoctorDataVerificationModal = ({
  show,
  ShowClose,
  doctorData,
  vendor_id,
  division_id,
}) => {
  const dispatch = useDispatch();
  const [verifiedList, setVerifiedList] = useState([]);
  const [isCheckAll, setIsCheckAll] = useState(false);
  const [bulkUploadData, setBulkUploadData] = useState([]);
  const [doctorBluckStatusData, setDoctorBluckStatusData] = useState("");
  const [doctorErrorModal, setDoctorErrorModal] = useState(false);
  const [showUnablePopup, setShowUnablePopup] = useState(false);
  const [showUnableMsg, setShowUnableMsg] = useState("");
  const [showErrorPopup, setShowErrorPopup] = useState(false);
  const [showErrorMsg, setShowErrorMsg] = useState("");
  const [showSuccessPopup, setShowSuccessPopup] = useState(false);
  const [showSuccessMsg, setShowSuccessMsg] = useState("");

  const checkedDoctor = (e, data) => {
    const { checked } = e.target;
    let newArr = verifiedList;
    setVerifiedList([...newArr, data]);
    if (!checked) {
      setVerifiedList(
        verifiedList.filter(
          (item) => JSON.stringify(item) !== JSON.stringify(data)
        )
      );
    }
  };

  const checkAll = (e) => {
    const { checked } = e.target;
    setIsCheckAll(checked);
    if (checked) {
      setVerifiedList(doctorData?.doctorData);
    } else {
      setVerifiedList([]);
    }
  };

  useEffect(() => {
    console.log(verifiedList);
    if (verifiedList?.length != doctorData?.doctorData?.length) {
      setIsCheckAll(false);
    } else {
      setIsCheckAll(true);
    }
  }, [verifiedList]);

  useEffect(() => {
    setBulkUploadData(doctorData?.doctorData);
  }, [doctorData]);

  const verifyDoctorHandler = () => {
    dispatch(
      doctorBulkVerify(
        {
          vendor_id,
          division_id,
          doctorData: verifiedList,
        },
        onVerifySuccess,
        onVerifyError
      )
    );
  };

  const searchHandler = (e) => {
    let newArr = doctorData.doctorData.filter(
      (doctor) =>
        doctor.name.toLowerCase().includes(e.target.value.toLowerCase()) ||
        doctor.mobile.toLowerCase().includes(e.target.value.toLowerCase()) ||
        doctor.email.toLowerCase().includes(e.target.value.toLowerCase())
    );
    setBulkUploadData(newArr);
  };

  const timeOutFnc = () => {
    setShowSuccessPopup(false);
    setShowUnablePopup(false);
    setDoctorErrorModal(true);
    setIsCheckAll(false);
  }

  const onVerifySuccess = (data) => {
    console.log(data);
    ShowClose();
    setDoctorBluckStatusData(data?.data?.data);
    const str = (data.data.message);
    const str_modify = str.charAt(0).toUpperCase() + str.slice(1);
    if (data.data.message == "unable to create doctor" || data.data.message == "unable to create doctors") {
      setShowUnablePopup(true);
      setShowUnableMsg(str_modify)
    } else {
      setShowSuccessPopup(true);
      setShowSuccessMsg(str_modify);
    }
    setTimeout(timeOutFnc, 2000);
    setVerifiedList([]);
  };

  const closeErrorPopup = () => {
    setShowErrorPopup(false)
  }

  const onVerifyError = (err) => {
    console.log(err);
    const str = (err.data.message);
    const str_modify = str.charAt(0).toUpperCase() + str.slice(1);
    setShowErrorMsg(str_modify);
    setShowErrorPopup(true);
    setVerifiedList([]);
  };

  return (
    <>
      <Modal
        centered
        show={show}
        onHide={ShowClose}
        dialogClassName="field-force-table-container col-10 px-5 mx-auto"
      //   size="sm"
      >
        <ModalHeader className="d-flex justify-content-between align-items-center">
          <div>
            <span className="fn_Nunito fw_600 fs_18">
              Doctor Data Verification -
              <span className="fw_500">
                {" "}
                {doctorData?.original_name?.length > 35
                  ? doctorData?.original_name?.substring(0, 35) + "..."
                  : doctorData?.original_name}
              </span>
            </span>
          </div>
          <div className=" d-flex justify-content-between m-1 mb-2">
            <AdminButton
              background="#E7E5FF"
              width="100px"
              type="button"
              onClick={() => ShowClose()}
            >
              CLOSE
            </AdminButton>
            <AdminButton
              background="#2AD3E7"
              color="white"
              width="100px"
              type="button"
              disabled={verifiedList?.length == 0}
              onClick={verifyDoctorHandler}
            >
              <span className="m-2">VERIFY</span>
            </AdminButton>
          </div>
        </ModalHeader>
        <ModalBody className="text-nowrap">
          <div className="modal-table-container" >
            <div className="search-container d-flex justify-content-between ">
              <div className="search-box w-50 d-flex align-items-center p-2 ms-3 m-1 mb-2">
                <img className="styled-SVG" src={searcher} color={""} />
                <input
                  className="search-input fs_14 fw_400 px-2"
                  type="text"
                  placeholder="Search Doctor here by Doctor Name..."
                  onChange={searchHandler}
                />
              </div>
            </div>
            <div className="table-container text-nowrap" style={{ minHeight: "36rem", maxHeight: "36rem" }}>
              <table className="main-table" >
                <tr className="table-rows color_747f9e">
                  <th className="table-heads " width={"4%"}>
                    <input
                      type={"checkbox"}
                      className="CheckBox my-1"
                      value="Full order forward from CFA"
                      name="ReimbursementCheck"
                      checked={isCheckAll}
                      onChange={checkAll}
                    />
                  </th>
                  <th className="table-heads " width={"4%"}>
                    SL. No.
                  </th>
                  <th className="table-heads " width={"10%"}>
                    Doctor Name
                  </th>
                  <th className="table-heads " width={"10%"}>
                    Mobile Number
                  </th>
                  <th className="table-heads " width={"10%"}>
                    Email Address
                  </th>
                  <th className="table-heads " width={"22%"}>
                    Actions
                  </th>
                </tr>
                {bulkUploadData?.length > 0 &&
                  bulkUploadData?.map((eachRow, index) => (
                    <DoctorVerificationTableData
                      data={eachRow}
                      key={index}
                      checkedDoctor={checkedDoctor}
                      isChecked={verifiedList.includes(eachRow)}
                    />
                  ))}
              </table>
            </div>
          </div>
        </ModalBody>
      </Modal>
      <DoctorBulkErrorModal
        show={doctorErrorModal}
        ShowClose={() => setDoctorErrorModal(false)}
        doctorBluckStatusData={doctorBluckStatusData}
      />
      <UnablePopup
        show={showUnablePopup}
        title={showUnableMsg}
      />

      <SuccessPopup
        show={showSuccessPopup}
        title={showSuccessMsg}
      />

      <ErrorPopup
        show={showErrorPopup}
        title={showErrorMsg}
        handleClose={closeErrorPopup}
      />
    </>
  );
};

export default DoctorDataVerificationModal;
